"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserInfoEditViewModel = instanceOfUserInfoEditViewModel;
exports.UserInfoEditViewModelFromJSON = UserInfoEditViewModelFromJSON;
exports.UserInfoEditViewModelFromJSONTyped = UserInfoEditViewModelFromJSONTyped;
exports.UserInfoEditViewModelToJSON = UserInfoEditViewModelToJSON;
exports.UserInfoEditViewModelToJSONTyped = UserInfoEditViewModelToJSONTyped;
/**
 * Check if a given object implements the UserInfoEditViewModel interface.
 */
function instanceOfUserInfoEditViewModel(value) {
    return true;
}
function UserInfoEditViewModelFromJSON(json) {
    return UserInfoEditViewModelFromJSONTyped(json, false);
}
function UserInfoEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'uNo': json['uNo'] == null ? undefined : json['uNo'],
        'uId': json['uId'] == null ? undefined : json['uId'],
        'uGw': json['uGw'] == null ? undefined : json['uGw'],
        'uNewGw': json['uNewGw'] == null ? undefined : json['uNewGw'],
        'uNewGwCheck': json['uNewGwCheck'] == null ? undefined : json['uNewGwCheck'],
        'uEid': json['uEid'] == null ? undefined : json['uEid'],
        'uName': json['uName'] == null ? undefined : json['uName'],
        'uBirthday': json['uBirthday'] == null ? undefined : json['uBirthday'],
        'uOid': json['uOid'] == null ? undefined : json['uOid'],
        'uDepartment': json['uDepartment'] == null ? undefined : json['uDepartment'],
        'uJobName': json['uJobName'] == null ? undefined : json['uJobName'],
        'uTel': json['uTel'] == null ? undefined : json['uTel'],
        'uCell': json['uCell'] == null ? undefined : json['uCell'],
        'uEmail': json['uEmail'] == null ? undefined : json['uEmail'],
        'uDisableda': json['uDisableda'] == null ? undefined : json['uDisableda'],
        'uResign': json['uResign'] == null ? undefined : json['uResign'],
        'oGroup': json['oGroup'] == null ? undefined : json['oGroup'],
    };
}
function UserInfoEditViewModelToJSON(json) {
    return UserInfoEditViewModelToJSONTyped(json, false);
}
function UserInfoEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uNo': value['uNo'],
        'uId': value['uId'],
        'uGw': value['uGw'],
        'uNewGw': value['uNewGw'],
        'uNewGwCheck': value['uNewGwCheck'],
        'uEid': value['uEid'],
        'uName': value['uName'],
        'uBirthday': value['uBirthday'],
        'uOid': value['uOid'],
        'uDepartment': value['uDepartment'],
        'uJobName': value['uJobName'],
        'uTel': value['uTel'],
        'uCell': value['uCell'],
        'uEmail': value['uEmail'],
        'uDisableda': value['uDisableda'],
        'uResign': value['uResign'],
        'oGroup': value['oGroup'],
    };
}
